const goTop = () => {
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};

const buttonGoTop = document.querySelector('.go-top-arrow');

const checkOffset = () => {
    const header = document.querySelector('header');
    const scrolledArea = -document.body.getBoundingClientRect().top;

    if (scrolledArea < header.getBoundingClientRect().height) {
        buttonGoTop.style.position = 'absolute';
        buttonGoTop.style.visibility = 'hidden';
    } else {
        buttonGoTop.style.position = 'fixed';
        buttonGoTop.style.visibility = 'visible';
    }
}

if (buttonGoTop) {
    buttonGoTop.addEventListener('click', (e) => {
        e.stopPropagation();
        goTop();
    });
    document.addEventListener('scroll', checkOffset);
}
